export default {
    setFirstLogin(value) {
        localStorage.setItem('key_ftth_data', value)
    },
    unLinkAccount(account) {
        var data = JSON.parse(localStorage.getItem("key_ftth_data"))
        var newData = []
        console.log('account unlink: ' + account)
        data.forEach(item=> {
            if(item.account !== account) {
                newData.push(item)
            }
        })
        console.log('unlink '+  JSON.stringify(newData))
        localStorage.setItem('key_ftth_data', JSON.stringify(newData))
    },
    addAccount(account) {
        // account current
        var data = localStorage.getItem("key_ftth_data")
        // account new
        var mergedArray = JSON.parse(account) ?? []
        if (mergedArray) {
            data = JSON.parse(data) ?? []
            mergedArray.forEach(item => {
                var flag = true
                for (const element of data) {
                    if (element.account === item.account) {
                        flag = false
                        break;
                    }
                }
                if (flag)
                    data.push(item)
            })
        }
        localStorage.setItem('key_ftth_data', JSON.stringify(data))
    },
    getFtthAccount(){
        return localStorage.getItem('key_ftth_data')
    }
}